module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-05-f03a6455d6b64e9db99ccf6ec4352a03.svg";